import { registerCondition } from "../conditionRegisterer.mjs";
export var CONDITION_NAME = 'false';

/**
 * @returns {boolean}
 */
export function condition() {
  return false;
}
registerCondition(CONDITION_NAME, condition, {
  name: 'False'
});


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/filters/condition/false.mjs
// module id = 1384
// module chunks = 1